import React, { Dispatch, useEffect } from 'react';
import { Col, Row, Collapse, Form, Input } from 'antd';
import { Action } from 'typesafe-actions';
import { useDispatch, useSelector } from 'react-redux';
import FilterContainer from '../../../../components/FilterContainer';
import { ApplicationState } from '../../../../store';
import { loadRequest } from '../../../../store/ducks/listarVeiculos/actions';
import CollapseTitle from '../../../../components/TitleCollapseFilter';
import FilterBtn from '../../../../components/FilterBtn';
import ClearFilterBtn from '../../../../components/ClearFilterBtn';
import CollapseFilter from '../../../../components/CollapseFilter';
import TextFilter from '../../../../components/TextFilter';
const { Panel } = Collapse;

const Filter: React.FC = () => {
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const dispatch = useDispatch<Dispatch<Action>>();

  useEffect(() => {
    const controller = new AbortController();
    if (inscricaoAtiva.length > 0) {
      dispatch(loadRequest(inscricaoAtiva));
    }
    return () => {
      controller.abort();
    };
  }, [inscricaoAtiva, cddAtivo, dispatch]);

  const onFilter = (values: any) => {
    dispatch(loadRequest(inscricaoAtiva, values));
    localStorage.setItem(window.location.pathname + `valuesFilter`, JSON.stringify(values));
  };

  const clearFilter = () => {
    // dispatch(cleanStateMotorista());
    dispatch(loadRequest(inscricaoAtiva));
    localStorage.removeItem(window.location.pathname + `valuesFilter`);
  };

  const localStorageItensPersist: string = JSON.parse(
    localStorage.getItem(window.location.pathname + `valuesFilter`) || '{}'
  );

  return (
    <CollapseFilter>
      <Panel header={<CollapseTitle>Filtro</CollapseTitle>} key="1">
        <FilterContainer onFilter={onFilter} initialValues={localStorageItensPersist}>
          <Row gutter={24}>
            <Col md={8} sm={24} xs={24}>
              <Form.Item name="placa" label={<TextFilter>Placa</TextFilter>}>
                <Input placeholder="Digite a placa do veículo" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24} justify="end">
            <Col md={6} sm={24} xs={24}>
              <ClearFilterBtn onClick={clearFilter}>Limpar filtros</ClearFilterBtn>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <FilterBtn>Filtrar</FilterBtn>
            </Col>
          </Row>
        </FilterContainer>
      </Panel>
    </CollapseFilter>
  );
};

export default Filter;
